import React, { useState } from 'react';
import { useAccessibility } from '../utils/accessibility';

interface PreHeaderProps {
  onToggleMenu: () => void;
  onToggleFooter: () => void;
  isMenuVisible: boolean;
  isFooterVisible: boolean;
}

export const PreHeader: React.FC<PreHeaderProps> = ({
  onToggleMenu,
  onToggleFooter,
  isMenuVisible,
  isFooterVisible
}) => {
  const { getText } = useAccessibility();

  const scrollToMainContent = () => {
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.scrollIntoView({ behavior: 'smooth' });
      mainContent.focus();
    }
  };

  const scrollToMenu = () => {
    onToggleMenu();
    if (!isMenuVisible) {
      setTimeout(() => {
        const headerNav = document.getElementById('header-navigation');
        if (headerNav) {
          headerNav.scrollIntoView({ behavior: 'smooth' });
          headerNav.focus();
        }
      }, 100);
    }
  };

  const scrollToFooter = () => {
    onToggleFooter();
    if (!isFooterVisible) {
      setTimeout(() => {
        const footer = document.getElementById('site-footer');
        if (footer) {
          footer.scrollIntoView({ behavior: 'smooth' });
          footer.focus();
        }
      }, 100);
    }
  };

  return (
    <div className="bg-primary-50 px-10 py-2 text-sm fixed top-0 left-0 right-0 z-50">
      <div className="max-w-[1440px] mx-auto flex gap-6">
        <button
          onClick={scrollToMainContent}
          className="text-primary-600 hover:text-primary-800 underline bg-transparent border-none cursor-pointer"
          aria-label={getText('navigation.skipToContent')}
        >
          Aller au contenu
        </button>
        <button
          onClick={scrollToMenu}
          className="text-primary-600 hover:text-primary-800 underline bg-transparent border-none cursor-pointer"
          aria-label={getText('navigation.toggleMenu')}
        >
          {isMenuVisible ? 'Cacher le menu' : 'Afficher le menu'}
        </button>
        <button
          onClick={scrollToFooter}
          className="text-primary-600 hover:text-primary-800 underline bg-transparent border-none cursor-pointer"
          aria-label={getText('navigation.skipToFooter')}
        >
          Aller au pied de page
        </button>
      </div>
    </div>
  );
};